import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import {
  EntityType,
  listOrganizationsWithTotalBudgetAmountQuery,
  Organization,
} from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type OrganizationModel = getEntityType<VendorsState>;

export interface VendorsState
  extends ActiveState<string>,
    EntityState<
      Omit<
        RequireSome<Partial<Organization>, 'id' | 'name'>,
        'baseline_budget_version' | 'contacts' | 'current_budget_versions' | 'parent_organization'
      > &
        Partial<Pick<listOrganizationsWithTotalBudgetAmountQuery, 'current_budget_versions'>> & {
          baseline_budget_version?:
            | null
            | undefined
            | {
                bucket_key?: null | string;
                budget_name?: string;
                budget_type?: string;
                budget_version_id?: string;
                entity_id?: string;
                entity_type?: EntityType;
                manual_forecast?: boolean;
              };
          budget_version: Record<
            string,
            {
              bucket_key: string;
              budget_name: string;
              budget_version_id: string;
              manual_forecast: boolean;
              total_budget_amount: number;
            }
          >;
          parent_organization?: null | {
            id: string;
            name: string;
          };
        }
    > {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'organization' })
export class OrganizationStore extends EntityStore<VendorsState> {
  constructor() {
    super({});
  }
}
